import { useLang } from './lang';

export function Wordmark() {
  return (
    <span className="wordmark" translate="no">
      IRIS
      <span className="wordmark-dot" aria-hidden="true" />
    </span>
  );
}

/** Slash eyebrow; the slash leads in reading order for both directions. */
export function Eyebrow({ k, tone = 'ink' }: { k: string; tone?: 'ink' | 'paper' }) {
  const { t } = useLang();
  return (
    <p className={`eyebrow eyebrow-${tone}`}>
      <span className="eyebrow-slash" aria-hidden="true">
        /
      </span>
      <span>{t(k)}</span>
    </p>
  );
}
